<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/134oFOm/tc-custom/9781460300305.jpg?1704297300023" alt="This image is the cover for the book Garden of Stones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Garden of Stones
      </h1>
      <p class="bookDescription body article font2">
        <b>“Suspense, mystery, and love” fill a multigenerational “moving drama of women in a Japanese American family. . . . The shocking revelation is unforgettable” (<i>Booklis</i>t).</b><br/><br/>In the dark days of World War II, a mother makes the ultimate sacrifice<br/><br/>Lucy Takeda is just fourteen years old, living in Los Angeles, when the bombs rain down on Pearl Harbor. Within weeks, she and her mother, Miyako, are ripped from their home, rounded up—along with thousands of other innocent Japanese-Americans—and taken to the Manzanar prison camp.<br/><br/>Buffeted by blistering heat and choking dust, Lucy and Miyako must endure the harsh living conditions of the camp. Corruption and abuse creep into every corner of Manzanar, eventually ensnaring beautiful, vulnerable Miyako. Ruined and unwilling to surrender her daughter to the same fate, Miyako soon breaks. Her final act of desperation will stay with Lucy forever . . . and spur her to sins of her own.<br/><br/>Bestselling author Sophie Littlefield weaves a powerful tale of stolen innocence and survival that echoes through generations, reverberating between mothers and daughters. It is a moving chronicle of injustice, triumph and the unspeakable acts we commit in the name of love.<br/><br/>“Littlefield . . . makes her tale resonant and universal . . . gripping.” —<i>Publishers Weekly</i><br/><br/>“Littlefield shows considerable skills for delving into the depths of her characters and complex plotting as she disarms the reader.” —<i>South Florida Sun-Sentinel</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sophie Littlefield
      </h2>
      
      <p class="authorDescription body article">Sophie Littlefield grew up in rural Missouri and attended college in Indiana. She worked in technology before having children, and was lucky enough to stay home with them while they were growing up. She writes novels for kids and adults, and lives in Northern California. Visit her online at www.SophieLittlefield.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79e5c630